import { getDoc, setDoc } from "firebase/firestore"
import dayjs from "dayjs"

export default defineNuxtPlugin(() => {
  if (!process.client) return
  if (import.meta.dev) {
    console.log("[migrate] skipped in dev mode")
    return
  }

  const bootstrapStore = useBootstrapStore()
  const shopStore = usePosShopStore()
  const settingsStore = useSettingsStore()
  const dataservice = useDataservice()
  const firestore = useFirestore()
  const { $api } = useApi()

  let hasRun = false

  const runMigration = async () => {
    if (hasRun) return
    hasRun = true

    const migratedRef = firestore.getMigratedDocRef()

    const snap = await getDoc(migratedRef)
    if (snap.exists() && snap.data()?.inventory) {
      console.log("[migrate] inventory already migrated:", snap.data().inventory)
      return
    }

    try {
      await dataservice.migrateStockTransactions.postWithQuery({
        beginDate: "2026-05",
      })

      try {
        const { apiBase } = useRuntimeConfig().public
        const customerId = dataservice.customerId.value
        const res = await $api(`https://api-app2.niceloop.com/public/check-app2-version`, {
          method: "POST",
          query: { customerId },
        })
        console.log("[migrate] check-app2-version flagged", res)
      } catch (err) {
        console.error("[migrate] check-app2-version failed", err)
      }

      await setDoc(
        migratedRef,
        {
          inventory: dayjs().toISOString(),
          name: settingsStore.getStoreName(),
        },
        { merge: true }
      )
      console.log("[migrate] inventory migration complete")
    } catch (err) {
      hasRun = false
      console.error("[migrate] inventory migration failed", err)
    }
  }

  const shouldRunMigration = computed(() => {
    return bootstrapStore.loaded && shopStore.runMode === "cashier"
  })

  watch(
    shouldRunMigration,
    (enabled, previousEnabled) => {
      if (enabled === previousEnabled) return
      if (!enabled) return
      void runMigration()
    },
    { immediate: true }
  )
})
